const NAMESPACE = "incentiveSelector";

const KEYS = {
    selectPrompt: "selectPrompt",
    adminOverrideControlsLabel: "adminOverrideControlsLabel",
    adminOverrideControlsHelpMessage: "adminOverrideControlsHelpMessage",
    overriddenAmountLabel: "overriddenAmountLabel",
    reasonForOverrideLabel: "reasonForOverrideLabel",
    adminOverrideDefaultDetails: "adminOverrideDefaultDetails",
    notYetCalculatedMessage: "notYetCalculatedMessage",
    hideCalculationDetailsButtonLabel: "hideCalculationDetailsButtonLabel",
    showCalculationDetailsButtonLabel: "showCalculationDetailsButtonLabel",
    updateButtonLabel: "updateButtonLabel",
    calculateButtonLabelText: "calculateButtonLabelText",
    incentiveLabelNoneSelectedText: "incentiveLabelNoneSelectedText",
    incentiveLabelIncentiveSelectedText: "incentiveLabelIncentiveSelectedText",
    calculatedAmountLabelNoneSelectedText: "calculatedAmountLabelNoneSelectedText",
    calculatedAmountLabelIncentiveSelectedText: "calculatedAmountLabelIncentiveSelectedText",
    calculateIncentiveErrorMessage: "calculateIncentiveErrorMessage",
    pvSystemCalculationRequiredMessage: "pvSystemCalculationRequiredMessage",
    pvSystemUncalculatedErrorMessage: "pvSystemUncalculatedErrorMessage",
    incentiveRecalculationDialogTitle: "incentiveRecalculationDialogTitle",
    incentiveRecalculationDialogMessage: "incentiveRecalculationDialogMessage",
    incentiveRecalculationDialogOkButtonLabel: "incentiveRecalculationDialogOkButtonLabel",
    incentiveRecalculationAdminDialogTitle: "incentiveRecalculationAdminDialogTitle",
    incentiveRecalculationAdminDialogMessage: "incentiveRecalculationAdminDialogMessage",
    incentiveRecalculationAdminDialogConfirmButtonLabel: "incentiveRecalculationAdminDialogConfirmButtonLabel",
    incentiveRecalculationAdminDialogCancelButtonLabel: "incentiveRecalculationAdminDialogCancelButtonLabel",
    incentiveEligibilityAdminDialogTitle: "incentiveEligibilityAdminDialogTitle",
    incentiveEligibilityAdminDialogMessage: "incentiveEligibilityAdminDialogMessage",
    incentiveEligibilityAdminDialogConfirmButtonLabel: "incentiveEligibilityAdminDialogConfirmButtonLabel",
    incentiveEligibilityAdminDialogCancelButtonLabel: "incentiveEligibilityAdminDialogCancelButtonLabel",
    projectIsIneligibleForSelectedIncentiveMessage: "projectIsIneligibleForSelectedIncentiveMessage",
    previousIncentiveAmountClearedMessage: "previousIncentiveAmountClearedMessage",
    incentiveChangeWarningDialogTitle: "incentiveChangeWarningDialogTitle",
    incentiveChangeWarningConfirmButtonLabel: "incentiveChangeWarningConfirmButtonLabel"
};

const MESSAGES = {
    [KEYS.selectPrompt]: {
        value: "Select an incentive...",
        comment: "Label for selector when no incentive has been selected"
    },
    [KEYS.adminOverrideControlsLabel]: {
        value: "Admin Override Controls",
        comment: "Label for admin incentive override section"
    },
    [KEYS.adminOverrideControlsHelpMessage]: {
        value: "(Changes will be reflected when you click the {buttonLabel} button.)",
        comment: "Message explaining what will happen when using admin incentive overrides"
    },
    [KEYS.overriddenAmountLabel]: {
        value: "Overridden Amount",
        comment: "Label for overridden amount field"
    },
    [KEYS.reasonForOverrideLabel]: {
        value: "Reason for Override",
        comment: "Label for override reason field"
    },
    [KEYS.adminOverrideDefaultDetails]: {
        value: "Admin Override",
        comment: "Default Admin Override 'calculation details' if no reason for the override was provided"
    },
    [KEYS.notYetCalculatedMessage]: {
        value: "Not yet calculated.",
        comment: "Label for when incentive amount has not yet been calculated"
    },
    [KEYS.hideCalculationDetailsButtonLabel]: {
        value: "Hide Details",
        comment: "Label for button toggling showing calculation details when details are shown"
    },
    [KEYS.showCalculationDetailsButtonLabel]: {
        value: "Show Details",
        comment: "Label for button toggling showing calculation details when details are not shown"
    },
    [KEYS.updateButtonLabel]: {
        value: "Update",
        comment: "Label for button to calculate incentive when in override mode"
    },
    [KEYS.calculateButtonLabelText]: {
        value: "Calculate Incentive",
        comment: "Label for button to calculate incentive when not in admin override mode"
    },
    [KEYS.incentiveLabelNoneSelectedText]: {
        value: "Incentive Amount:",
        comment: "Label for incentive amount when in admin override and no incentive selected"
    },
    [KEYS.incentiveLabelIncentiveSelectedText]: {
        value: "Incentive Amount for {name}:",
        comment: "Label for incentive amount when in admin override and an incentive is selected"
    },
    [KEYS.calculatedAmountLabelNoneSelectedText]: {
        value: "Calculated Amount:",
        comment: "Label for incentive amount when not in admin override and no incentive selected"
    },
    [KEYS.calculatedAmountLabelIncentiveSelectedText]: {
        value: "Calculated Amount for {name}:",
        comment: "Label for incentive amount when not in admin override and an incentive is selected"
    },
    [KEYS.calculateIncentiveErrorMessage]: {
        value: "Please select an incentive and be sure the associated PV system has been calculated.",
        comment: "Error message if calculation cannot be successfully calculated"
    },
    [KEYS.pvSystemCalculationRequiredMessage]: {
        value: "Please calculate the PV System and then recalculate your incentive.",
        comment: "Message displayed when the related PV System must be calculated and the incentive recalculated"
    },
    [KEYS.pvSystemUncalculatedErrorMessage]: {
        value: "The PV system must be calculated before calculating this incentive.",
        comment: "Error message displayed when the incentive calculation fails due to an uncalculated PV system"
    },
    [KEYS.incentiveCalculationFailedDialogTitle]: {
        value: "Incentive Calculation Failed",
        comment: "Title of dialog displayed when an incentive calculation fails"
    },
    [KEYS.incentiveRecalculationDialogTitle]: {
        value: "Incentive Recalculation",
        comment: "Title of dialog displayed when an input change triggers an incentive recalculation"
    },
    [KEYS.incentiveRecalculationDialogMessage]: {
        value: "Modifying this data field will require your incentive to be recalculated, which may change your incentive amount.",
        comment: "Text in dialog displayed when an input change triggers an incentive recalculation"
    },
    [KEYS.incentiveRecalculationDialogOkButtonLabel]: {
        value: "Ok - Continue",
        comment: "Label for Ok button in dialog displayed when an input change triggers an incentive recalculation"
    },
    [KEYS.incentiveRecalculationAdminDialogTitle]: {
        value: "Confirm Save and Recalculate Incentive",
        comment:
            "Title of dialog displayed from the Admin page when an input change triggers an incentive recalculation"
    },
    [KEYS.incentiveRecalculationAdminDialogMessage]: {
        value: "Modifying this data field will require the incentive to be recalculated, which may change the incentive amount. Changes need to be saved before continuing. If you do not save, the current incentive amount will be cleared. Do you wish to save and continue?",
        comment: "Text in dialog displayed from the Admin page when an input change triggers an incentive recalculation"
    },
    [KEYS.incentiveRecalculationAdminDialogConfirmButtonLabel]: {
        value: "Save and Continue",
        comment:
            "Label for confirmation button in dialog displayed from the Admin page when an input change triggers an incentive recalculation"
    },
    [KEYS.incentiveRecalculationAdminDialogCancelButtonLabel]: {
        value: "Clear Incentive Amount",
        comment:
            "Label for cancel button in dialog displayed from the Admin page when an input change triggers an incentive recalculation"
    },
    [KEYS.incentiveEligibilityAdminDialogTitle]: {
        value: "Confirm Save and Reevaluate Incentive Eligiblity",
        comment:
            "Title of dialog displayed from the Admin page when an input change triggers a reevaluation of incentive eligiblity"
    },
    [KEYS.incentiveEligibilityAdminDialogMessage]: {
        value: "Modifying this data field will require incentive eligibility conditions to be reevaluated, and the currently selected incentive may no longer be available. Changes need to be saved before continuing.  If you do not save, the current incentive selection and amount (if any) will be cleared. Do you wish to save and continue?",
        comment:
            "Text in dialog displayed from the Admin page when an input change triggers a reevaluation of incentive eligiblity"
    },
    [KEYS.incentiveEligibilityAdminDialogConfirmButtonLabel]: {
        value: "Save and Continue",
        comment:
            "Label for confirmation button in dialog displayed from the Admin page when an input change triggers a reevaluation of incentive eligiblity"
    },
    [KEYS.incentiveEligibilityAdminDialogCancelButtonLabel]: {
        value: "Clear Current Incentive",
        comment:
            "Label for cancel button in dialog displayed from the Admin page when an input change triggers a reevaluation of incentive eligiblity"
    },
    [KEYS.projectIsIneligibleForSelectedIncentiveMessage]: {
        value: "The project is no longer eligible for the previously selected incentive due to a recent input change.",
        comment: "Text displayed when the project is not eligible for the selected incentive design"
    },
    [KEYS.previousIncentiveAmountClearedMessage]: {
        value: "The previously calculated incentive amount has been cleared.",
        comment: "Text displayed when the previous incentive amount has been cleared due to other changes"
    },
    [KEYS.incentiveChangeWarningDialogTitle]: {
        value: "Incentive Change",
        comment: "Title of dialog displayed when the previous incentive amount has been cleared due to other changes"
    },
    [KEYS.incentiveChangeWarningConfirmButtonLabel]: {
        value: "OK",
        comment:
            "Label for confirmation button in dialog displayed when the previous incentive amount has been cleared due to other changes"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
